// extracted by mini-css-extract-plugin
export default {"menu":"ActionsPopup_menu__AuS79","menuItem":"ActionsPopup_menuItem__KFDgR"};